import {
  getWebInstrumentations,
  initializeFaro,
  type Faro,
} from '@grafana/faro-web-sdk'

let faro: Faro | null = null

export function initFaro(): void {
  if (faro) return
  const url = import.meta.env.VITE_FARO_URL as string | undefined
  if (!url) return

  faro = initializeFaro({
    url,
    apiKey: import.meta.env.VITE_FARO_API_KEY as string | undefined,
    app: {
      name: 'provenance-web',
      version: (import.meta.env.VITE_APP_VERSION as string) ?? '0.0.0',
      environment: import.meta.env.MODE,
    },
    instrumentations: [...getWebInstrumentations()],
  })
}

export function pushClientError(error: unknown): void {
  const err = error instanceof Error ? error : new Error(String(error))
  if (faro) {
    faro.api.pushError(err)
  } else {
    console.error(err)
  }
}
